// ----------------------------------------------------------------------

const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/dashboard',
  SYSTEM: '/system',
  PUBLIC: '/ps',
  COMPANION: '/cd',
  ONLINE_PAYMENT: '/online-payment',
};

// ----------------------------------------------------------------------

export const paths = {
  minimalUI: '/dashboard', // TODO: Find every instance of this and remove it
  // AUTH
  auth: {
    login: `${ROOTS.AUTH}/login`,
    loginCompanion: `${ROOTS.AUTH}/login-companion`,
    loginPointPay: `${ROOTS.AUTH}/p/login`,
    v3DeviceLogin: `${ROOTS.AUTH}/v3-device-login`,
    // register: `${ROOTS.AUTH}/jwt/register`,
    // verify: `${ROOTS.AUTH}/jwt/verify`,
    // forgotPassword: `${ROOTS.AUTH}/jwt/forgot-password`,

    // firebase: {
    //   // login: `${ROOTS.AUTH}/firebase/login`,
    //   verify: `${ROOTS.AUTH}/firebase/verify`,
    //   // register: `${ROOTS.AUTH}/firebase/register`,
    //   forgotPassword: `${ROOTS.AUTH}/firebase/forgot-password`,
    // },
  },
  system: {
    updateVersion: `${ROOTS.SYSTEM}/update-version`,
    contactSupport: `${ROOTS.SYSTEM}/contact-support`,
    offline: `${ROOTS.SYSTEM}/offline`,
    permissions: `${ROOTS.SYSTEM}/permissions`,
  },
  companion: {
    root: `${ROOTS.COMPANION}`,
    menu: `${ROOTS.COMPANION}/menu`,
    selfCheckout: `${ROOTS.COMPANION}/self-checkout`,
    customerFacing: `${ROOTS.COMPANION}/customer-facing`,
    digitalSignage: `${ROOTS.COMPANION}/digital-signage`,
    kitchenDisplay: `${ROOTS.COMPANION}/kitchen-display`,
    notSetup: `${ROOTS.COMPANION}/not-setup`,
  },
  // DASHBOARD
  // This page is connected to src/routes/sections/dashboard.tsx
  // If you change the path here, you must also change the path in the dashboard.tsx file
  dashboard: {
    root: ROOTS.DASHBOARD,
    apps: `${ROOTS.DASHBOARD}/dashboard`,
    pos: `${ROOTS.DASHBOARD}/pos`,
    posV2: `${ROOTS.DASHBOARD}/pos-v2`,
    quickPay: `${ROOTS.DASHBOARD}/quick-pay`,
    transactions: {
      root: `${ROOTS.DASHBOARD}/transactions`,
      // history: `${ROOTS.DASHBOARD}/transactions/history`,
      details: (id: string) => `${ROOTS.DASHBOARD}/transactions/details/${id}`,
    },
    reports: {
      root: `${ROOTS.DASHBOARD}/reports`,
      tab: (tab?: string) => `${ROOTS.DASHBOARD}/reports/${tab}`,
    },
    inventory: {
      root: `${ROOTS.DASHBOARD}/inventory`,
      menu: `${ROOTS.DASHBOARD}/inventory/menu`,
    },
    customers: {
      root: `${ROOTS.DASHBOARD}/customers`,
      details: (id: string) => `${ROOTS.DASHBOARD}/customers/details/${id}`,
    },
    settings: {
      root: `${ROOTS.DASHBOARD}/settings`,
    },
    inventoryTools: {
      root: `${ROOTS.DASHBOARD}/inventory-tools`,
    },
    admin: {
      root: `${ROOTS.DASHBOARD}/admin`,
      tab: (tab?: string) => (tab ? `${ROOTS.DASHBOARD}/admin/${tab}` : `${ROOTS.DASHBOARD}/admin`),
      singleUser: (id: string) => `${ROOTS.DASHBOARD}/admin/user/${id}`,
      singleBusiness: (id: string) => `${ROOTS.DASHBOARD}/admin/business/${id}`,
      businessesDetail: (id: string) => `${ROOTS.DASHBOARD}/admin/businesses/${id}`,
    },
    mobileTopup: {
      root: `${ROOTS.DASHBOARD}/mobile-topup`,
    },
    orders: {
      root: `${ROOTS.DASHBOARD}/orders`,
    },
    ebtTransactions: {
      root: `${ROOTS.DASHBOARD}/ebt-transactions`,
    },
    v3: {
      root: `${ROOTS.DASHBOARD}/v3`,
      pos: `${ROOTS.DASHBOARD}/v3/pos`,
      selfCheckout: `${ROOTS.DASHBOARD}/v3/restaurant-self-checkout`,
    },
    v4: {
      root: `${ROOTS.DASHBOARD}/v4`,
      payment: `${ROOTS.DASHBOARD}/v4/payment`,
      transactions: `${ROOTS.DASHBOARD}/v4/transactions`,
      inventory: `${ROOTS.DASHBOARD}/v4/inventory`,
      restaurantPos: `${ROOTS.DASHBOARD}/v4/restaurant-pos`,
      mobileInventory: `${ROOTS.DASHBOARD}/v4/mobile-inventory`,
      customers: {
        root: `${ROOTS.DASHBOARD}/v4/customers`,
        details: (id: string) => `${ROOTS.DASHBOARD}/v4/customers/${id}`,
      },
    },
    public: {
      receipt: (id: string) => `${ROOTS.PUBLIC}/receipt/${id}`,
      menu: `${ROOTS.PUBLIC}/menu`,
    },

    // three: `${ROOTS.DASHBOARD}/three`,
    // group: {
    //   root: `${ROOTS.DASHBOARD}/group`,
    //   five: `${ROOTS.DASHBOARD}/group/five`,
    //   six: `${ROOTS.DASHBOARD}/group/six`,
    // },
  },

  pointPay: {
    root: `${ROOTS.ONLINE_PAYMENT}`,
    dashboard: `${ROOTS.ONLINE_PAYMENT}`,
    settings: `${ROOTS.ONLINE_PAYMENT}/settings`,
    transactions: `${ROOTS.ONLINE_PAYMENT}/transactions`,
    customers: `${ROOTS.ONLINE_PAYMENT}/customers`,
    paymentLinks: `${ROOTS.ONLINE_PAYMENT}/payment-links`,
  },
};
